import client from '../client';
import type { ApiResponse } from '../../types/api';

export interface ProductCode {
  _id: string;
  value: string;
  status: 'available' | 'reserved' | 'revealed';
  orderId?: string | null;
  orderRef?: string | null;
  buyer?: {
    username?: string;
    email?: string;
    phone?: string;
  } | null;
  reservedAt?: string | null;
}

export interface ProductCodeStats {
  total: number;
  available: number;
  reserved: number;
  revealed: number;
}

export const productCodesApi = {
  list: async (storeId: string, productId: string, params?: { status?: string; search?: string; limit?: number; skip?: number }) => {
    const res = await client.get<ApiResponse<{ codes: ProductCode[]; stats: ProductCodeStats; product: { _id: string; productId: string; title: string } }>>(
      `/dashboard/${storeId}/products/${productId}/codes`,
      { params },
    );
    return res.data.data!;
  },

  add: async (storeId: string, productId: string, codes: string[]) => {
    const res = await client.post<ApiResponse<{ addedCount: number; duplicatesRemoved: number }>>(
      `/dashboard/${storeId}/products/${productId}/codes`,
      { codes },
    );
    return res.data.data!;
  },

  delete: async (storeId: string, productId: string, codeIds: string[]) => {
    const res = await client.delete<ApiResponse<{ deletedCount: number }>>(
      `/dashboard/${storeId}/products/${productId}/codes`,
      { data: { codeIds } },
    );
    return res.data.data!;
  },

  updateCode: async (storeId: string, productId: string, codeId: string, value: string) => {
    await client.patch(`/dashboard/${storeId}/products/${productId}/codes/${codeId}`, { value });
  },

  exportCsv: async (storeId: string, productId: string, status?: string) => {
    const res = await client.get<ApiResponse<{ csv: string; filename: string; count: number }>>(
      `/dashboard/${storeId}/products/${productId}/codes/export`,
      { params: status ? { status } : undefined },
    );
    return res.data.data!;
  },
};
